<template>
  <main>
    <transition name="fade">
      <Loader v-if="!$page" />
    </transition>
    <template v-if="$page">
      <section class="not-found__header section" data-light-menu="true">
        <h1 class="not-found__header-title">{{ $page.header.title }}</h1>
        <p class="not-found__header-description">{{ $page.header.description }}</p>
        <LangRouterLink :to="{ name: 'home' }" class="button not-found__header-button">
          {{ $page.header.button }}
        </LangRouterLink>
      </section>
      <section class="section not-found__content" data-light-menu="false">
        <h2>{{ $page.jobs.title }}</h2>
        <p class="not-found__content-description">{{ $page.jobs.description }}</p>
        <div class="jobs__container">
          <JobCard :content="job" v-for="(job, jobIndex) in recentJobs" :key="jobIndex" />
        </div>
        <LangRouterLink
          :to="{ name: 'home', hash: '#jobs' }"
          class="button -dark not-found__content-button"
          >{{ $page.jobs.button }}</LangRouterLink
        >
      </section>
    </template>
  </main>
</template>

<script>
import JobCard from '@/components/cards/JobCard.vue'
import LangRouterLink from '@/components/global/LangRouterLink.vue'
import Loader from '@/components/small/Loader.vue'
import HasRecentJobs from '@/mixins/HasRecentJobs.js'
import PageMetaMixin from '@/mixins/PageMetaMixin.js'

export default {
  name: 'NotFound',
  beetPage: 'not_found',
  mixins: [HasRecentJobs, PageMetaMixin],
  components: {
    JobCard,
    LangRouterLink,
    Loader,
  },
}
</script>
